import { trackSelfDescribingEvent } from "@catchoftheday/analytics";

export const MENU_CLICK_SCHEMA =
  "iglu:au.com.catch/menu_click/jsonschema/1-0-0";
export const MENU_IMPRESSION_SCHEMA =
  "iglu:au.com.catch/menu_impression/jsonschema/1-0-0";

export type ItemPath = {
  name: string;
  id: number;
  position: number;
};

type MenuTrackImpression = {
  name: string;
  item_path: ItemPath[] | undefined;
};

type MenuTrackClick = { url: string } & MenuTrackImpression;

export function trackMenuClick({ name, url, item_path }: MenuTrackClick) {
  trackSelfDescribingEvent({
    event: {
      schema: MENU_CLICK_SCHEMA,
      data: {
        name,
        url,
        item_path,
      },
    },
  });
}

export function trackMenuImpression({ name, item_path }: MenuTrackImpression) {
  trackSelfDescribingEvent({
    event: {
      schema: MENU_IMPRESSION_SCHEMA,
      data: {
        name,
        item_path,
      },
    },
  });
}
